import React, { useState } from 'react';
import { TextField } from '@cimpress/react-components';

const TextFieldExamplePattern = () => {
  const [text, setText] = useState('');

  const onInputChange = e => {
    setText(e.target.value);
  };

  return (
    <TextField
      name="pattern"
      label="Pattern Text Field where only A is accepted"
      value={text}
      onChange={e => e.isValid && onInputChange(e)}
      pattern="[A]*"
    />
  );
};

export default TextFieldExamplePattern;
